import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M9.25 5.75H8.75V6.25H9.25V5.75Z" fill="currentColor" stroke="none" />
		<Path d="M9.25 11.75H8.75V12.25H9.25V11.75Z" fill="currentColor" stroke="none" />
		<Path d="M9.25 17.75H8.75V18.25H9.25V17.75Z" fill="currentColor" stroke="none" />
		<Path d="M15.25 5.75H14.75V6.25H15.25V5.75Z" fill="currentColor" stroke="none" />
		<Path d="M15.25 11.75H14.75V12.25H15.25V11.75Z" fill="currentColor" stroke="none" />
		<Path d="M15.25 17.75H14.75V18.25H15.25V17.75Z" fill="currentColor" stroke="none" />
		<Path d="M9.25 5.75H8.75V6.25H9.25V5.75Z" vectorEffect="non-scaling-stroke" />
		<Path d="M9.25 11.75H8.75V12.25H9.25V11.75Z" vectorEffect="non-scaling-stroke" />
		<Path d="M9.25 17.75H8.75V18.25H9.25V17.75Z" vectorEffect="non-scaling-stroke" />
		<Path d="M15.25 5.75H14.75V6.25H15.25V5.75Z" vectorEffect="non-scaling-stroke" />
		<Path d="M15.25 11.75H14.75V12.25H15.25V11.75Z" vectorEffect="non-scaling-stroke" />
		<Path d="M15.25 17.75H14.75V18.25H15.25V17.75Z" vectorEffect="non-scaling-stroke" />
	</SVG>
);
